/**
 * Settings screen — camera + UI preferences, reference-styled.
 * The camera-drag toggle here and the one on the skirmish setup screen
 * both read/write the shared `settings` store, so they can never disagree.
 */
import { settings } from "./settings";

export class SettingsScreen {
  private el: HTMLDivElement;
  private unsub: (() => void) | null = null;

  constructor(private onBack: () => void) {
    this.el = document.createElement("div");
    this.el.className = "lg-screen";
    this.el.id = "lg-settings";
    this.el.style.display = "none";
    this.el.innerHTML =
      `<div class="lg-sky"></div><div class="lg-scrim"></div><div class="lg-vig"></div>` +
      `<div class="lg-body">` +
      `<div class="lg-crumb lg-anim">Legionnaire</div>` +
      `<div class="lg-title lg-anim lg-d1" style="font-size:clamp(26px,5.4vw,40px)">SETTINGS</div>` +
      `<div class="lg-card lg-anim lg-d2" style="margin-top:20px">` +
      `<div class="lg-hd" style="margin-top:0">Camera</div>` +
      `<button class="lg-toggle" id="lg-set-invert" aria-pressed="false">` +
      `<span>Camera drag</span><span class="tk"></span></button>` +
      `<div class="lg-note" id="lg-set-invert-desc" style="margin:8px 0 14px"></div>` +
      `<div class="lg-slider"><span>Speed</span>` +
      `<input type="range" id="lg-set-speed" min="0.5" max="2" step="0.1" value="1" aria-label="Camera speed"/>` +
      `<b id="lg-set-speed-val" style="color:var(--bronze-lt);min-width:36px;text-align:right">1.0×</b></div>` +
      `</div>` +
      `<div class="lg-btn-row lg-anim lg-d3" style="margin-top:20px;max-width:640px">` +
      `<button class="lg-btn primary" id="lg-set-back">Back</button>` +
      `</div>` +
      `</div>`;
    this.el
      .querySelector("#lg-set-back")!
      .addEventListener("click", () => this.onBack());
    this.el
      .querySelector("#lg-set-invert")!
      .addEventListener("click", () => {
        const cur = settings.get().cameraInvert;
        settings.update({ cameraInvert: !cur });
      });
    this.el
      .querySelector("#lg-set-speed")!
      .addEventListener("input", (e) => {
        const v = parseFloat((e.target as HTMLInputElement).value);
        settings.update({ cameraSpeed: v });
      });
    document.body.appendChild(this.el);
    this.unsub = settings.onChange(() => this.refresh());
    this.refresh();
  }

  private refresh(): void {
    const s = settings.get();
    const t = this.el.querySelector("#lg-set-invert") as HTMLButtonElement;
    t.setAttribute("aria-pressed", s.cameraInvert ? "true" : "false");
    (this.el.querySelector("#lg-set-invert-desc") as HTMLDivElement).textContent =
      s.cameraInvert
        ? "Inverted — drag moves the camera with your finger (legacy RTS feel)."
        : "Standard — the world follows your finger (Google Maps feel).";
    (this.el.querySelector("#lg-set-speed") as HTMLInputElement).value = String(
      s.cameraSpeed,
    );
    (this.el.querySelector("#lg-set-speed-val") as HTMLElement).textContent =
      `${s.cameraSpeed.toFixed(1)}×`;
    // First button label doubles as the toggle state for touch users.
    t.querySelector("span")!.textContent = s.cameraInvert
      ? "Camera drag — inverted"
      : "Camera drag — world follows finger";
  }

  show(): void {
    this.refresh();
    this.el.style.display = "";
  }

  hide(): void {
    this.el.style.display = "none";
  }

  destroy(): void {
    this.unsub?.();
    this.el.remove();
  }
}
